"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeChiefAdminRole = void 0;
const index_1 = require("./index");
const base_model_1 = require("../base-model");
class ChangeChiefAdminRole extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return index_1.changeChiefAdminRole;
    }
}
exports.ChangeChiefAdminRole = ChangeChiefAdminRole;
